import { createSlice } from "@reduxjs/toolkit";
import { linkToUsAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const linkToUsSlice = createSlice({
  name: "linkToUs",
  initialState: data,
  reducers: {
    linkToUsSlice(state) {
      state.isLoading = false;
    },
    linkToUsSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    linkToUsSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    linkToUsSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const linkToUsHandler = () => async (dispatch: any) => {
  try {
    dispatch(linkToUsAction.linkToUsSlice());
    const response: any = await linkToUsAPI();
    dispatch(linkToUsAction.linkToUsSliceSuccess(response));
  } catch (e: any) {
    dispatch(linkToUsAction.linkToUsSliceFailure(e?.response?.data?.message));
    dispatch(linkToUsAction.linkToUsSliceReset());
  }
};
export default linkToUsSlice.reducer;
export const linkToUsAction = linkToUsSlice.actions;
